// extracted by mini-css-extract-plugin
module.exports = {"invoiceAmount":"invoiceAccount_invoiceAmount__OzF_l"};